import React from "react";
import { connect } from "react-redux";
import {
  ResultadosGanadores,
  ResultadosGenerales,
  ResultadosRama,
  ResultadosCategoria,
  controlesArrayFunc,
  ImprimirDatos,
} from "./reportsLogic";
import { calcularSubclasificacion } from "./subclasificacionesLogic";

import "materialize-css/dist/css/materialize.min.css";
import Row from "./RowResultReport";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Box from "@material-ui/core/Box";

import Background from "../../../assets/backgroundPhotos/fondogris_Dashport.jpg";

class ResultsReportNewView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filas: [],
      filasTotal: [],
      keepRendering: false,
      modalidadFiltro: null,
    };
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll, true);
    this.refreshReport();
  };
  componentDidUpdate(prevProps, prevState) {
    const {
      eventResults,
      puntosControl,
      reportResultType,
      controles,
      eventConfiguration,
      eventDetail,
      eventSubEvents,
    } = this.props;

    if (
      prevProps.eventResults !== eventResults ||
      prevProps.puntosControl !== puntosControl ||
      prevProps.reportResultType !== reportResultType ||
      prevProps.controles !== controles ||
      prevProps.eventConfiguration !== eventConfiguration ||
      prevProps.eventDetail !== eventDetail ||
      prevProps.eventSubEvents !== eventSubEvents ||
      prevState.modalidadFiltro !== this.state.modalidadFiltro
    ) {
      this.refreshReport();
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll, true);
  };

  handleScroll = () => {
    this.setState({
      keepRendering: true,
    });
    this.recursive();
  };

  recursive = () => {
    setTimeout(() => {
      const { filas, filasTotal } = this.state;
      // Antes decía "filas.length + 1 < filasTotal.length" — cuando a filas
      // le faltaba exactamente 1 fila para alcanzar a filasTotal (ej. 30 de
      // 31), esa condición ya daba false y se detenía la carga sin mostrar
      // jamás la última fila.
      const hasMore = filas.length < filasTotal.length;

      if (!hasMore) return;

      this.setState((prevState) => ({
        filas: prevState.filasTotal.slice(0, prevState.filas.length + 10),
      }));
    }, 0);
  };

  getModalidadesArray = () => {
    const { eventSubEvents } = this.props;
    if (!eventSubEvents) return [];

    return Object.keys(eventSubEvents)
      .map((key) => eventSubEvents[key])
      .filter((item) => item && item.codigoModalidad !== undefined);
  };

  filtrarResultadosPorModalidad = (resultados = []) => {
    const modalidadFiltro = this.state ? this.state.modalidadFiltro : null;

    if (!modalidadFiltro) return resultados;

    return resultados.filter(
      (item) => item && Number(item.codMod) === Number(modalidadFiltro)
    );
  };
  getReportData = () => {
    console.log("ImprimirDatos")
    if (
      !this.props.eventDetail ||
      !this.props.eventConfiguration
    ) {
      return [];
    }
    console.log("ImprimirDatos")
    const iDEvento = this.props.eventDetail.iDEvento;

    let checkControls = false;
    if (this.props.controles && this.props.puntosControl !== undefined) {
      checkControls = true;
    }
    if (!this.props.controles) {
      checkControls = true;
    }

    let resultadosOrdendos = [];
    let resultadosBase = [];

    if (this.props.eventResults !== undefined && checkControls) {
      resultadosBase = Array.isArray(this.props.eventResults)
        ? this.props.eventResults
        : Object.values(this.props.eventResults || {});

      const modalidadFiltro = this.state ? this.state.modalidadFiltro : null;

      if (modalidadFiltro !== null && modalidadFiltro !== undefined) {
        resultadosBase = resultadosBase.filter(
          (item) => item && Number(item.codMod) === Number(modalidadFiltro)
        );
      }
      console.log("ImprimirDatos", resultadosOrdendos);

      if (this.props.reportResultType === 4) {
        resultadosOrdendos = ResultadosGanadores(resultadosBase);
      } else if (this.props.reportResultType === 1) {
        resultadosOrdendos = ResultadosGenerales(resultadosBase);
      } else if (this.props.reportResultType === 2) {
        resultadosOrdendos = ResultadosRama(resultadosBase);
      } else if (this.props.reportResultType === 3) {
        resultadosOrdendos = ResultadosCategoria(resultadosBase);
      } else {
        resultadosOrdendos = resultadosBase;
      }
    }

    let filas = ImprimirDatos(
      resultadosOrdendos,
      this.props.reportResultType,
      false,
      this.props.controles,
      iDEvento,
      this.props.eventConfiguration.timingConfig || false
    );

    // El tab Ganadores, además de absolutos/categorías, también muestra los
    // ganadores de cada subclasificación que tenga cantidadGanadores
    // configurado — una sección más por subclasificación, al final (mismo
    // criterio que ResultsReportNewAUTH.jsx en el panel admin).
    if (this.props.reportResultType === 4) {
      const subclasificaciones =
        (this.props.eventConfiguration.timingConfig &&
          this.props.eventConfiguration.timingConfig.subclasificaciones) ||
        {};
      Object.keys(subclasificaciones).forEach((id) => {
        const def = subclasificaciones[id];
        if (!def.cantidadGanadores) return;
        const ganadoresSub = calcularSubclasificacion(resultadosBase, id)
          .filter((r) => r.pSub !== null && r.pSub <= def.cantidadGanadores)
          .map((r) => ({ ...r, nombreSubclasificacion: def.nombre }));
        if (ganadoresSub.length) {
          filas = filas.concat(
            ImprimirDatos(
              ganadoresSub,
              5,
              false,
              this.props.controles,
              iDEvento,
              this.props.eventConfiguration.timingConfig || false
            )
          );
        }
      });
    }

    return filas || [];
  };
  refreshReport = () => {
    const filas = this.getReportData();
    this.setState({
      filas: filas.slice(0, 20),
      filasTotal: filas,
    });
  };
  handleFiltroModalidad = (codigoModalidad) => {
    this.setState(
      {
        modalidadFiltro: codigoModalidad,
      },
      this.refreshReport
    );
  };

  limpiarFiltroModalidad = () => {
    this.setState(
      {
        modalidadFiltro: null,
      },
      this.refreshReport
    );
  };
  renderFiltrosModalidad = () => {
    const modalidades = this.getModalidadesArray();
    const { modalidadFiltro } = this.state;

    if (!modalidades.length) return null;

    return (
      <Box
        mb={2}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          alignItems: "center",
        }}
      >
        <ButtonGroup
          variant="contained"
          color="primary"
          size="small"
          style={{ flexWrap: "wrap", boxShadow: "none" }}
        >
          <Button
            onClick={this.limpiarFiltroModalidad}
            variant={modalidadFiltro === null ? "contained" : "outlined"}
          >
            Todas
          </Button>

          {modalidades.map((modalidad) => (
            <Button
              key={modalidad.codigoModalidad}
              onClick={() =>
                this.handleFiltroModalidad(modalidad.codigoModalidad)
              }
              variant={
                Number(modalidadFiltro) === Number(modalidad.codigoModalidad)
                  ? "contained"
                  : "outlined"
              }
            >
              {modalidad.descripcionModalidad}
            </Button>
          ))}
        </ButtonGroup>
      </Box>
    );
  };

  render() {
    let element = "";

    if (
      this.props.eventDetail !== undefined &&
      (this.props.puntosControl !== undefined || !this.props.controles)
    ) {
      let controlesArray;
      if (this.props.controles) {
        controlesArray = controlesArrayFunc(this.props.puntosControl);
      }

      element = (
        <>
          {this.renderFiltrosModalidad()}

          <TableContainer
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Table
              size="small"
              style={{
                width: "100%",
                tableLayout: "auto",
                backgroundImage: `url(${Background})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
              id="Tabla-1"
              className="bordered centered highlight"
            >
              <TableHead />
              <TableBody id="Resultados">

                {this.state.filas.map((data, index) => (
                  <Row
                    key={index}
                    data={data}
                    controlesArray={controlesArray}
                    controles={this.props.controles}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      );
    } else {
      element = <h5>Cargando</h5>;
    }

    return element;
  }
}

const mapDispatchToProps = () => {
  return {};
};

const mapStateToProps = (state) => {
  return {
    eventDetail: state.events.eventDetail,
    eventResults: state.events.eventResults,
    puntosControl: state.events.puntosControl,
    eventConfiguration: state.events.eventConfiguration,
    eventSubEvents: state.events.eventSubEvents,
  };
};

const ResultsReportNew = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultsReportNewView);

export default ResultsReportNew;